export const getKeys = (value) => {
    return Object.keys(value);
};